import { getItem, removeItem, setItem } from '@/tools';
import { Collapse, message } from 'antd';
import axios from 'axios';
import { t } from 'i18next';
import {closeWebSocket} from "../utils";
import {showWarningMessageBox} from "../components/ShowMessageBox";
const { Panel } = Collapse;

//获取环境变量(看属于哪种部署环境) START || DEV || STAG || PROD
const envType = process.env['REACT_APP_ENV'];

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env[envType].url1 : '',
  timeout: 30000,
});

//请求拦截
instance.interceptors.request.use(
  (config) => {
    const token = getItem('token');
    config.headers['Authorization'] = 'Bearer ' + token;
    config._requestStartTime = Date.now();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const AUTH_ERROR_MSG_MAP = {
    TOKEN_EXPIRED: 'login.tokenExpired',
    TOKEN_INVALID: 'login.idleTimeout',
    TOKEN_ERROR: 'login.tokenError',
    NO_TOKEN: 'login.authFailed',
};

//响应拦截
instance.interceptors.response.use(
    async (res) => {
        const startTime = res.config?._requestStartTime;
        const duration = startTime ? Date.now() - startTime : 0;
        const url = res.config?.url || '';
        console.log(`[HTTP] ${url} status=${res.status} duration=${duration}ms`);

        //所有数据状态码 200 201 401 402 403 900
        if (res.status >= 200 && res.status < 300) {
            //1.页面请求资源接口,用户没有登录 2.token已过期
            if (res.data.code === 401) {
                removeItem('token');
                removeItem('userId');
                closeWebSocket();

                const msgKey = AUTH_ERROR_MSG_MAP[res.data?.msg];
                const msg = msgKey ? t(msgKey) : t('login.authFailed');
                await showWarningMessageBox(msg);

                window.location.href = '#/login';
                return Promise.reject(new Error('Authenticate failed'));
            }

            //403 没有权限跳转首页
            if (res.data.code === 403) {
                const reqUrl = res.config?.url;
                if (reqUrl !== '/my-support-bff/vehicle/token') {
                    return (window.location.href = '#/');
                }
            }

            //弹出错误信息
            if (res.data.code === 201 || res.data.code === 900) {
                //修改密码，旧密码不正确，文案提示翻译
                if (res.data?.msg?.includes('The origin password you entered is incorrect')) {
                    return message.error(t('changePassword.oldIncorrect'));
                }

                return message.error(
                    <span>
                        <span>System error</span>
                        <Collapse ghost>
                          <Panel header={<div style={{ textAlign: 'left' }}>Error details</div>} key="1">
                            <p>{res?.data?.msg}</p>
                          </Panel>
                        </Collapse>
                    </span>
                );

                // return message.error(res?.data?.msg);
            }

            //1.登录成功 2.token即将过期续时  获取token，并保存
            const token = res.headers['token'];
            if (token) {
                setItem('token', token);
            }

            return res.config?.resolveFullResponse ? res : res.data;
        }
        return Promise.reject(res.statusText);
    },
  (error) => {
      // 对于 skipErrorMessage 的情况，直接返回错误，不弹出提示框
      // 一般这种情况，会单独针对这个接口请求做错误处理，而不是全局提示
    if (error?.config?.skipErrorMessage) {
      return Promise.reject(error);
    }

    const startTime = error.config?._requestStartTime;
    const duration = startTime ? Date.now() - startTime : 0;
    const url = error.config?.url || '';
    const isTimeout = error.code === 'ECONNABORTED' || error.message?.includes('timeout');
    console.log(`[HTTP] ${url} ERROR duration=${duration}ms timeout=${isTimeout} message=${error.message}`);

    const errorMessage = error?.response?.data?.msg || error?.response?.data?.message || error?.message;
    if (errorMessage) {
      message.error(errorMessage);
    }

    return Promise.reject(error);
  }
);

export default instance;
